import { jsx as _jsx } from "react/jsx-runtime";
const Image = ({ classes, imageClasses, url, alt }) => {
    return (_jsx("figure", { className: classes ? classes : `bg-grey-50 overflow-hidden`, children: _jsx("img", { src: url, alt: alt, className: imageClasses ? imageClasses : `aspect-3/2 object-cover w-full transition-transform duration-500 ease-in-out group-hover:scale-104` }) }));
};
export default Image;
